import { formatNumber } from './formatNumber';
import { NBSP } from '../../constants/symbols';

export const formatMoney = (money: number): string => {
  return `${formatNumber(money)}${NBSP}₽`;
};
